import React from 'react'
import Link from 'components/link'
import Font from '@cred/react-font'

const CogFinDisclosure = () => (
  <Font type="disclaimer" weight="semiBold" color="secondary" className="align-left">
    <Link
      blank
      rel="nofollow"
      href="https://www.credible.com/a/cogfin-disclosures"
    >
      Cognition Financial Disclosure
    </Link>
  </Font>
)
export default CogFinDisclosure
